// extracted by mini-css-extract-plugin
export default {"wrapper":"InputImage_wrapper__Tb10Y","title":"InputImage_title__RwVs9","image_wrapper":"InputImage_image_wrapper__tP01l"};